import type { StateType } from '../../reducers';

export const regionSelector = (state: StateType): ?Region => state.signUp.region;
